"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noScrollBarScrollPan = zebra.Class(zebra.ui.ScrollPan, [
    function (c, barMask) {
        this.setAutoHide(true);
        this.$super.apply(this, arguments);
    },
    function posChanged(target, prevOffset, prevLine, prevCol) {
        if (this.isPosChangedLocked === false) {
            if (this.autoHide) {
                this.$dontHide = true;
                if (this.$interval === 0 && ((this.vBar !== null && this.vBar.isVisible === true) ||
                    (this.hBar !== null && this.hBar.isVisible === true))) {
                    var $this_1 = this;
                    this.vrp();
                    this.$interval = setInterval(function () {
                        if ($this_1.$dontHide || ($this_1.vBar !== null && this.$mouseMoveOwner === $this_1.vBar) ||
                            ($this_1.hBar !== null && this.$mouseMoveOwner === $this_1.hBar)) {
                            $this_1.$dontHide = false;
                        }
                        else {
                            clearInterval($this_1.$interval);
                            $this_1.$interval = 0;
                            $this_1.doLayout();
                        }
                    }, 0);
                }
            }
            if (this.vBar !== null && this.vBar.position === target) {
                this.scrollObj.scrollManager.scrollYTo((-1) * this.vBar.position.offset);
            }
            else {
                if (this.hBar !== null) {
                    this.scrollObj.scrollManager.scrollXTo((-1) * this.hBar.position.offset);
                }
            }
        }
    }
]);
//# sourceMappingURL=NoScrollBarScrollPan.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/NoScrollBarScrollPan.js
// module id = 81
// module chunks = 0